module.exports = __webpack_public_path__ + "static/media/(V)_MG_5721_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_acess[orios.3bb88f91.jpg";